const SET_COMMUNITIES_DASHBOARD = (state, payload) => {
  state.currentOrigin.communitySummaries = payload.communities;

  state.user = payload.user;
  state.usageEventsDisabled = payload.usageEventsDisabled;
};

export default SET_COMMUNITIES_DASHBOARD;
